__turbopack_context__.v({
  "arrow": "RedListIndexMobileInfo-module__CoR99q__arrow",
  "caption": "RedListIndexMobileInfo-module__CoR99q__caption",
  "infoButton": "RedListIndexMobileInfo-module__CoR99q__infoButton",
  "panel": "RedListIndexMobileInfo-module__CoR99q__panel",
  "root": "RedListIndexMobileInfo-module__CoR99q__root",
  "stat": "RedListIndexMobileInfo-module__CoR99q__stat",
  "value": "RedListIndexMobileInfo-module__CoR99q__value",
});
